var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_33003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F89022"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 10.6661H14.4202L13.4769 9.85837L12.537 10.6627H11.4131L10.8759 10.0102H9.02419L9.49275 9.43144H10.4034L9.70987 8.58319L7.28831 11.5312H6.165L6.86588 10.6751H5.69531L5.0625 8.901L4.43475 10.6616H3.24731L2.25 7.89806H3.16125L3.83175 9.78019L4.5 7.9065H5.625L6.29156 9.77625L6.95756 7.90594H7.87163L6.86588 10.6751L7.08975 10.4018L9.144 7.90144H10.2746L11.9841 9.98719L12.8064 9.28012L10.2037 7.03125H11.5397L15.75 10.6661ZM14.4309 8.99437L13.8038 8.45663L14.4298 7.92338L15.6954 7.9245L14.4309 8.99437Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_33003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWax);
export default __webpack_public_path__ + "static/media/wax.9c5334ed02eb0e08ac5ccc5ffb07b071.svg";
export { ForwardRef as ReactComponent };